module.exports = __webpack_public_path__ + "static/media/scienceparrot.fdf734f0.gif";